(function () {
  if (window.rezuneAddToCartToastReady) return;
  window.rezuneAddToCartToastReady = true;

  var hideTimer;
  var removeTimer;

  function ensureStyles() {
    if (document.getElementById('rezune-cart-toast-inline-style')) return;

    var style = document.createElement('style');
    style.id = 'rezune-cart-toast-inline-style';
    style.textContent = [
      '.rezune-cart-toast{position:fixed;left:50%;bottom:max(22px,env(safe-area-inset-bottom));z-index:2147483647;display:inline-flex;align-items:center;justify-content:center;gap:10px;width:min(calc(100vw - 32px),420px);min-height:54px;padding:14px 20px;border-radius:999px;background:#168a43;color:#fff;box-shadow:0 16px 42px rgba(10,74,34,.28);font-family:var(--font-body-family);font-size:15px;font-weight:600;line-height:1;letter-spacing:0;pointer-events:none;opacity:0;transform:translate(-50%,28px);transition:opacity 240ms ease,transform 240ms ease;}',
      '.rezune-cart-toast.is-visible{opacity:1;transform:translate(-50%,0);}',
      '.rezune-cart-toast__icon{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;flex:0 0 auto;border-radius:50%;background:rgba(255,255,255,.18);}',
      '.rezune-cart-toast__icon svg{display:block;width:16px;height:16px;fill:currentColor;}',
      '@media screen and (max-width:749px){.rezune-cart-toast{top:calc(env(safe-area-inset-top) + 88px);bottom:auto;width:min(calc(100vw - 24px),360px);min-height:52px;font-size:14px;transform:translate(-50%,-22px);box-shadow:0 18px 46px rgba(10,74,34,.34);}.rezune-cart-toast.is-visible{transform:translate(-50%,0);}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getToast() {
    ensureStyles();

    var toast = document.querySelector('[data-add-to-cart-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'rezune-cart-toast';
    toast.setAttribute('data-add-to-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = [
      '<span class="rezune-cart-toast__icon" aria-hidden="true">',
        '<svg viewBox="0 0 20 20" focusable="false">',
          '<path d="M7.7 13.5 3.9 9.7l1.4-1.4 2.4 2.4 7-7 1.4 1.4-8.4 8.4Z"></path>',
        '</svg>',
      '</span>',
      '<span class="rezune-cart-toast__text">Product added to cart</span>'
    ].join('');

    document.body.appendChild(toast);
    return toast;
  }

  function showToast() {
    var toast = getToast();

    window.clearTimeout(hideTimer);
    window.clearTimeout(removeTimer);

    toast.classList.add('is-visible');

    hideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2000);

    removeTimer = window.setTimeout(function () {
      if (!toast.classList.contains('is-visible')) {
        toast.remove();
      }
    }, 2600);
  }

  window.rezuneShowAddToCartToast = showToast;

  function ajaxAddToCart(form) {
    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton && (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true')) return;

    var drawer = document.querySelector('cart-drawer');
    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error('Error adding product to cart:', response.description || response.message);
          return;
        }

        showToast();

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        }
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);
      })
      .finally(function () {
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('product-form')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    ajaxAddToCart(form);
  }, true);

  function subscribeToCartUpdates() {
    if (window.rezuneToastSubscribedToCartUpdates) return;
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS && typeof PUB_SUB_EVENTS === 'undefined') return;

    window.rezuneToastSubscribedToCartUpdates = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      showToast();
    });
  }

  subscribeToCartUpdates();
  document.addEventListener('DOMContentLoaded', subscribeToCartUpdates);
  window.addEventListener('load', subscribeToCartUpdates);

  if (!window.fetch || window.rezuneFetchToastPatched) return;
  window.rezuneFetchToastPatched = true;

  var originalFetch = window.fetch;

  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : request && request.url;
    var isCartAdd = url && url.indexOf('/cart/add') !== -1;

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartAdd && response && response.ok) {
        response.clone().json().then(function (data) {
          if (!data || !data.status) {
            showToast();
          }
        }).catch(function () {
          showToast();
        });
      }

      return response;
    });
  };
})();
